import React, { Component } from 'react';
import PropTypes from 'prop-types';
import { connect } from 'react-redux';
import {
  Grid,
  Row,
  Col,
} from 'react-bootstrap';
import withStyles from 'isomorphic-style-loader/lib/withStyles';
import cx from 'classnames';
import s from './HostingBlock.css';

class HostingBlock extends Component {
  render() {
    return (

      <Grid className={s.hostingsection}>
        <Row>
          <Col xs={12} sm={12} md={12} lg={12}>
            <div className={cx(s.seperator, s.boxseperator)}></div>
            <div className={cx(s.mainhedding, 'mainheddingRTLMobile')}>
              <h1>Just 3 easy steps</h1>
            </div>
            <Col xs={12} sm={12} md={4} lg={4}>
              <div className={s.steps}>
                <p className={s.circle}><span> 1 </span></p>
                <h4 className={s.common}>Powerful Search</h4>
                <p className={s.common}>Enter your desired location, dates and capacity requirements. </p>
              </div>
            </Col>
            <Col xs={12} sm={12} md={4} lg={4}>
              <div className={s.steps}>
                <p className={s.circle}><span> 2 </span></p>
                <h4 className={s.common}>360 Office Tour</h4>
                <p className={s.common}>Explore the space in a stunning 3D tour</p>
              </div>
            </Col>
            <Col xs={12} sm={12} md={4} lg={4}>
              <div className={s.steps}>
                <p className={s.circle}><span> 3 </span></p>
                <h4 className={s.common}>Book</h4>
                <p className={s.common}>Instant booking with instant confirmation.</p>
              </div>
            </Col>
          </Col>
        </Row>
      </Grid>
    );
  }
}

export default withStyles(s)(HostingBlock);



// WEBPACK FOOTER //
// src/components/FindOutMore/HostingBlock/HostingBlock.js